import { API } from 'src/utils/interceptor'

/**
 * How many basket lines someone else on the team added. 0 when unknown, so
 * the checkout warning only shows when we know it's true.
 *
 * @param {string} venueId
 * @returns {Promise<number>}
 */
export const fetchBasketLinesAddedByOthers = async venueId => {
  if (!venueId) return 0
  try {
    const response = await API.get('api2', 'order/basket-added-by-others', {
      queryStringParameters: { venueId },
    })
    const count = Number(response?.count)
    return Number.isFinite(count) && count > 0 ? count : 0
  } catch (error) {
    return 0
  }
}

/** Warning line for checkout, or null when nobody else added anything. */
export const sharedBasketWarning = count => {
  const n = Number(count)
  if (!Number.isFinite(n) || n < 1) return null
  return n === 1
    ? '1 item in this basket was added by someone else on your team. Check it before you send.'
    : `${n} items in this basket were added by someone else on your team. Check them before you send.`
}
